<template lang="pug">
	.folder-actions
		.folder-edit
			.actions-button(v-pseudo-modal-show="'folder-options-dropdown-' + index", @click="setTopY($event)")
				i.icons.cui-options
			.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'folder-options-dropdown-' + index" :style="{top: `${topY - 25 - 162}px`}")
				.dropdown-header.text-center
					strong Actions
				.dropdown-item(@click="renameFolder")
					span Rename folder
				.dropdown-item(@click="removeFolder")
					span Delete folder


</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { User } 			from './../../services/User';
	import { Template } 		from './../../services/Template';
	import { Monitoring } 		from './../../services/Monitoring';
	import {Project} from "@/services/Project";

	export default {
		name: "ProjectFolderActions",
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Folder Changed", "Selected Folder Changed"],
			events: {
				"Monitoring Channel Updated": function() {
					this.update();
				}
			}
		},
		props: ['index'],
		data() {

			this.User = User;
			this.Template = Template;
			this.Monitoring = Monitoring;

			this.topY = 0;

			this.copyState = {
				copy: true,
				paste: false,
				title: null
			};


			return {
				showed: true
			};

		},
		methods: {

			collectData() {

			},

			renameFolder() {

				Broadcast.call("Show Project Folder Actions Rename");

				Broadcast.call("Pseudo Modal Hide", ["folder-options-dropdown-" + this.index]);

			},

			removeFolder() {

				Broadcast.call("Show Project Folder Actions Delete");

				Broadcast.call("Pseudo Modal Hide", ["folder-options-dropdown-" + this.index]);

			},


			setTopY(event) {
				this.topY = event.clientY;
				this.$forceUpdate();
			}
		}
	}
</script>


<style lang="sass" scoped>


	.dropdown-menu
		right: -205px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

		.dropdown-item.disabled
			color: #73818f

		.icon
			margin-left: 6px

	.folder-actions
		display: flex
		align-items: center
		width: 15%

		&.selected
			background-color: #20a8d8

		&:hover
			color: #ababab

		.folder-edit
			padding: 0 1rem 0 0.4rem
</style>

